// string after the dot is kept of the length 2 to 12 to accept domains like verde.finance
// also allow +1 in email address
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// Regex to allow only numbers with up to two decimal places
export const percentageRegex = /^\d*\.?\d{0,2}$/;

// Regex to allow only numbers
export const numberRegex = /^\d+$/;
